import { createSlice } from "@reduxjs/toolkit";
import { getLocalItems, setLocalItems } from "../../helpers/storedItems";

const userClaims = getLocalItems("user-claims") || {};

const initialState = {
  ...userClaims,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    updateUserImage: (state, action) => {
      const updatedClaims = {
        ...state,
        picture: action.payload,
      };

      setLocalItems("user-claims", updatedClaims);

      state.picture = action.payload;
    },

    updateUserName: (state, action) => {
      const { firstName, lastName } = action.payload;

      const updatedClaims = {
        ...state,
        firstName,
        lastName,
      };

      setLocalItems("user-claims", updatedClaims);

      state.firstName = firstName;
      state.lastName = lastName;
    },
  },
});

export const { updateUserImage, updateUserName } = userSlice.actions;

export default userSlice.reducer;
